<template>
  <page :styles="styles" :default-banner="false" class="print-customer-form">
    <template slot="banner">
      <div
        style="width: 100%; margin-bottom: 8px"
        class="align-center justify-center row-reversable px-4"
      >
        <div
          style="
            flex: 1;
            display: flex;
            font-size: 12px;
            flex-direction: column;
            justify-content: center;
          "
          class="align-start"
        >
          <img
            alt="SO"
            class="bill_logo"
            :src="branch_logo"
            style="width: 2cm; height: auto"
          />
        </div>
        <div
          style="display: flex; justify-content: center; align-items: center"
        >
          <div class="font-weight-bold" style="text-align: center">
            <div class="font-weight-bold bill_title">{{ branch_fa_name }}</div>
            <div class="font-weight-bold bill_title">{{ LONG_APP_NAME }}</div>
            <div class="font-weight-bold bill_title">
              {{ $t("exchange_bill_title") }}
            </div>
          </div>
        </div>
        <div
          style="
            flex: 1;
            display: flex;
            font-size: 12px;
            flex-direction: column;
            justify-content: center;
          "
          class="align-end"
        >
          <span>
            <span class="pcf-label">{{ $t("tr") }}: </span>
            <span class="pcf-text">
              {{
                exchange.number || (system && system.last_form_number + 1)
              }}
            </span>
          </span>
          <span>
            <span class="pcf-label">{{ $t("date") }}: </span>
            <span class="pcf-text"
              >{{ exchange.date }} {{ exchange.time }}</span
            >
          </span>
          <span>
            <span class="pcf-label">{{ $t("persian_date") }}: </span>
            <span class="pcf-text">{{
              exchange.date | persianDateFilter(true)
            }}</span>
          </span>
        </div>
      </div>
    </template>

    <!-- <template slot="header">
      <th colspan="100%" class="justify-end py-0">
        <v-divider></v-divider>
      </th>
    </template> -->

    <template slot="body">
      <tr>
        <td
          colspan="100%"
          class="text-xs-left body-2 secondary white--text lr--text"
        >
          <span class="pcf-label">
            {{ $t("customer_details") }}
          </span>
        </td>
      </tr>
      <tr>
        <td class="lr--text">
          <span class="pcf-label">{{ $t("company") }}: </span>
          <span class="mx-2 pcf-text">{{ exchange.details.corporate_name }}</span>
        </td>
        <td class="lr--text">
          <span class="pcf-label">{{ $t("full_name") }}: </span>
          <span class="mx-2 pcf-text">{{ exchange.details.name }}</span>
        </td>
        <td colspan="2" class="lr--text">
          <span class="pcf-label">{{ $t("reg_no") }}: </span>
          <span class="mx-2 pcf-text">{{ exchange.details.reg_id }}</span>
        </td>
      </tr>
      <tr>
        <td colspan="2" class="lr--text">
          <span class="pcf-label">{{ $t("father_name") }}: </span>
          <span class="mx-2 pcf-text">{{ exchange.details.father_name }}</span>
        </td>
        <td colspan="2" class="lr--text">
          <span class="pcf-label">{{ $t(exchange.details.doctype) }}: </span>
          <span class="mx-2 pcf-text">{{ exchange.details.docno }}</span>
        </td>
      </tr>
      <tr>
        <td colspan="2"  class="lr--text">
          <span class="pcf-label">{{ $t("place_of_birth") }}: </span>
          <span class="mx-2 pcf-text">{{
            exchange.details.place_of_birth
          }}</span>
        </td>
        <td colspan="2"  class="lr--text">
          <span class="pcf-label">{{ $t("date_of_birth") }}: </span>
          <span class="mx-2 pcf-text">{{
            exchange.details.date_of_birth
          }}</span>
        </td>
      </tr>
      <tr>
        <td colspan="2"  class="lr--text">
          <span class="pcf-label">{{ $t("nationality") }}: </span>
          <span class="mx-2 pcf-text">{{ exchange.details.nationality }}</span>
        </td>
        <td colspan="2"  class="lr--text">
          <span class="pcf-label">{{ $t("occupation") }}: </span>
          <span class="mx-2 pcf-text">{{ exchange.details.occupation }}</span>
        </td>
      </tr>
      <tr>
        <td colspan="2"  class="lr--text">
          <span class="pcf-label">{{ $t("source_of_fund") }}: </span>
          <span class="mx-2 pcf-text">{{
            exchange.details.source_of_fund
          }}</span>
        </td>
        <td colspan="2"  class="lr--text">
          <span class="pcf-label">{{ $t("purpose_of_transaction") }}: </span>
          <span class="mx-2 pcf-text">{{
            exchange.details.purpose_of_transaction
          }}</span>
        </td>
      </tr>

      <tr>
        <td colspan="4"  class="lr--text">
          <span class="pcf-label">{{ $t("phones") }}: </span>
          <span class="mx-2 pcf-text">{{
            exchange.details.pretty_phones
          }}</span>
        </td>
      </tr>
      <tr>
        <td colspan="4"  class="lr--text">
          <span class="pcf-label">{{ $t("address") }}: </span>
          <span class="mx-2 pcf-text">{{ exchange.details.address }}</span>
        </td>
      </tr>
      <tr>
        <td colspan="100%" class="white py-2"></td>
      </tr>
      <tr class="mt-2">
        <td colspan="100%" class="lr--text body-2 secondary white--text">
          <span class="pcf-label">
            {{ $t("transaction_details") }}
          </span>
        </td>
      </tr>
      <tr>
        <td class="lr--text">
          <span class="pcf-label">{{ $t("buy_currency") }}</span>
        </td>
        <td colspan="3"  class="lr--text">
          <span class="pcf-text capitalize">
            {{
              exchange.exchanged_amount
                | currency({ symbol: smbl(exchange.buy_currency_id) })
            }}
            ({{ exchange.exchanged_amount | toWord }}
            {{ smbl(exchange.buy_currency_id) }})
          </span>
        </td>
      </tr>
      <tr>
        <td  class="lr--text">
          <span class="pcf-label">{{ $t("rate") }}</span>
        </td>
        <td colspan="3"  class="lr--text">
          <span class="pcf-text capitalize">
            {{ exchange.rate }}
          </span>
        </td>
      </tr>
      <tr>
        <td  class="lr--text">
          <span class="pcf-label">{{ $t("sale_currency") }}</span>
        </td>
        <td colspan="3"  class="lr--text">
          <span class="pcf-text capitalize">
            {{
              exchange.amount
                | currency({ symbol: smbl(exchange.sale_currency_id) })
            }}
            ({{ exchange.amount | toWord }}
            {{ smbl(exchange.sale_currency_id) }})
          </span>
        </td>
      </tr>
      <tr>
        <td colspan="100%" class="white px-0 pt-3 pb-2 lr--text">
          <p>
            <strong class="pcf-label">{{ $t("description") }} : </strong
            ><span class="pcf-text">{{ exchange.description }}</span>
          </p>
        </td>
      </tr>
    </template>
  </page>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    exchange: {
      default: () => ({
        customer_id: null,
        buy_customer_id: null,
        buy_currency_id: null,
        sale_currency_id: null,
        sale_customer_id: null,
        number: 1000,
        amount: 1000,
        rate: 76,
        exchanged_amount: null,
        exchanger: "Extenral Person",
        type: "sale",
        date: null,
        time: null,
        description: "First Exchange",
        details: {
          id: 1,
          exchange_id: 1,
          reg_id: "1000",
          name: "Mohmmad Ali",
          father_name: "Hassan",
          full_name: "1000 - Mohmmad Ali",
          doctype: "passport",
          docno: "P07878787878",
          nationality: "Afghan",
          issue_date: null,
          expire_date: null,
          place_of_birth: "Midan",
          date_of_birth: "2020-12-16",
          purpose_of_transaction: "Daily Usage",
          source_of_fund: "Daily Income",
          address: "Kabul, Share Naw",
          phones: ["07889898989", "08987222"],
          occupation: "Occupation",
          nature_of_business: null,
          created_at: "2020-12-17T07:25:08.000000Z",
          updated_at: "2020-12-17T07:25:08.000000Z",
          pretty_phones: "07889898989 - 08987222",
        },
      }),
    },
    system: { default: () => {} },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    items() {
      return this.dailyReport.items;
    },

    landscape() {
      return false;
    },

    styles() {
      if (this.landscape) return { "min-height": "200mm", width: "290mm" };
      return { "min-height": "auto", width: "200mm" };
    },
  },
  methods: {
    reset() {
      this.$router.go(-1);
    },
  },
};
</script>